"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCreateNewConversation = function SvgCreateNewConversation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1BBBC9",
    d: "M9 1a9 9 0 1 1 0 18A9 9 0 0 1 9 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1BBBC9",
    d: "M4 6.477h4v7H4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M7.713 6.5a.2.2 0 0 0-.2.2L7.5 12.3c0 .11.09.2.2.2h6.6a.2.2 0 0 0 .2-.2V6.7a.2.2 0 0 0-.2-.2H7.713z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1BBBC9",
    d: "M5 7h3v5H5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    d: "m8 7 2.966 2L14 7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.4 6.477h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 8.877v1H2v-1z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCreateNewConversation);
var _default = exports["default"] = Memo;